import { Component, OnInit, ChangeDetectorRef, ViewChild } from '@angular/core';

import { ConfirmComponent } from '../../modal/confirm.component';
import { Inspection, InspectionPlugin, Resource } from '../../shared/models/index';
import { PluginComponent } from '../plugin.component';
import { BasePlugin } from '../base-plugin.component';
import { ResourceType } from '../../utils/enums';
import * as _ from 'lodash';
import { IndexedDbService } from '../../shared/services/indexedDb.service';

@Component({
    templateUrl: './attachements.component.html',
    standalone: false
})
export class AttachementsPluginComponent extends BasePlugin implements OnInit {
  public plugin: any;
  public assets: any = [];
  public inspection: Inspection;
  @ViewChild('deleteConfirmAttachementsPlugin', { static: true }) deleteConfirm: ConfirmComponent;
  public selectedAsset: any;
  public assetUrls: any = {};

  constructor(private cdRef: ChangeDetectorRef, private indexedDb: IndexedDbService) {
    super();
  }

  ngOnInit() {}

  public getAssetUrl(asset: any) {
    if (this.inspection.isOffline && !this.isManager) {
      return this.assetUrls[asset.AssetId];
    } else {
      return `/api${asset.Url}/content/${asset.Name}`;
    }
  }

  config(
    plugin: any,
    inspection: Inspection,
    messages: Array<string>,
    showBreadcrumbs: boolean,
    showValidations: boolean,
    showContent: boolean
  ): void {
    super.config(plugin, inspection, messages, showBreadcrumbs, showValidations, showContent);
    if (this.plugin.config.AttachementDocuments) {
      for (let i = 0; i < this.plugin.config.AttachementDocuments.length; i++) {
        this.assets.push(this.plugin.config.AttachementDocuments[i]);
        if (this.inspection.isOffline) {
          this.indexedDb.getImageUrl(this.plugin.config.AttachementDocuments[i].AssetId).subscribe((url) => {
            this.assetUrls[this.plugin.config.AttachementDocuments[i].AssetId] = url;
          });
        }
      }
    }
    this.cdRef.detectChanges();
  }

  getDeleteRoute(asset: any) {
    return [
      this.inspectionsRoute,
      this.plugin.inspectionId,
      'points',
      this.plugin.pointId ? this.plugin.pointId : -1,
      'plugins',
      this.plugin.id,
      'attachements',
      asset.AssetId,
      'delete'
    ];
  }
  getAddRoute() {
    return [
      this.inspectionsRoute,
      this.inspection.id,
      'points',
      this.plugin.pointId ? this.plugin.pointId : -1,
      'plugins',
      this.plugin.id,
      'attachements',
      'add'
    ];
  }
}

PluginComponent.plugins['attachements'] = AttachementsPluginComponent;

PluginComponent.downloads['attachements'] = (plugin: InspectionPlugin) => {
  const resources: Resource[] = [];
  if (plugin.config != null && plugin.config.AttachementDocuments != null) {
    _.each(plugin.config.AttachementDocuments, (asset) => {
      resources.push(
        new Resource(ResourceType.Attachment, asset.AssetId, {
          url: asset.Url,
          name: asset.Name,
          type: asset.MimeType
        })
      );
    });
  }
  return resources;
};
